import { render, staticRenderFns } from "./relationship_information_sponsorship_evaluation.vue?vue&type=template&id=21bc23fc&"
import script from "./relationship_information_sponsorship_evaluation.vue?vue&type=script&lang=js&"
export * from "./relationship_information_sponsorship_evaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports